import i18n from "i18next";

import translationEn from "./locales/en/translation.json";
import translationEs from "./locales/es/translation.json";
import i18next from "i18next";

i18next
  .init({
    debug: false,
    lng: "en",
    fallbackLng: "en",

    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },

    resources: {
      en: {
        translations: translationEn,
      },
      es: {
        translations: translationEs,
      },
    },
    ns: ["translations"],
    defaultNS: "translations",
  });

export default i18n;